<section class="row makePaymentView" id="productList-area">
  <aside class="col-md-3 col-sm-3 col-lg-2 col-xs-12 applied-filter pr-0">
    <fieldset class="orderstatus-style">
      <div class="filterByGroup">
        <div class="filterByTitle">
          <label for="invoice">Payment type</label>
          <div>
            <ng-select name="orderstatus" [items]="PaymentMethodList" [searchable]="false" [clearable]="false"
              bindLabel="name" bindValue="code" class="dropdown-credit" (change)="onKeyPress($event)" dropdownPosition="bottom"
              [(ngModel)]="paymentMethod"></ng-select>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset id="filter-by">
      <legend class="filterByTitle-main order-history-search">
        {{ "ordersList.searchBy" | cxTranslate }}
      </legend>
      <div class="grey-line"></div>
      <div class="filterByGroup mb-3">
        <div class="filterByTitle">
          <label for="invoice">{{
            "ordersList.timeFrame" | cxTranslate
            }}</label>
        </div>
        <ng-select name="timeFrame" [items]="timeFrameList" [searchable]="false" [clearable]="false" bindLabel="name"
          bindValue="code" class="dropdown-credit" (ngModelChange)="clearDateRange()" [(ngModel)]="timeFrame">
        </ng-select>
      </div>

      <!--Date Range-->
      <div class="filterByGroup">
        <div class="filterByTitle mb-2">
          {{ "ordersList.dateRange" | cxTranslate }}
        </div>
        <div class="delivary-details">
          <div>
            <fieldset class="form-horizontal mb0">
              <legend class="control-group mb-2">
                <label for="fromDate" aria-labelledby="dataRange fromDate">{{
                  "ordersList.from" | cxTranslate
                  }}</label>
              </legend>
              <div class="headSearch-holder">
                <label class="searchbox orders-filter time-frame">
                  <img src="/icons/{{baseSiteId}}/calendar.svg" alt="" />
                  <input type="text" placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}" class="input-filter"
                    [(ngModel)]="fromDate" (ngModelChange)="validateDate()" bsDatepicker [minDate]="minSelectionDate"
                    [daysDisabled]="[0, 6]" [bsConfig]="{
                      containerClass: 'order-list-date',
                      dateInputFormat: 'MM/DD/YYYY'
                    }" />
                </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="delivary-details">
          <div>
            <fieldset class="form-horizontal mb0">
              <legend class="control-group mb-2">
                <label for="toDate" aria-labelledby="dataRange toDate">{{
                  "ordersList.to" | cxTranslate
                  }}</label>
              </legend>
              <div class="headSearch-holder">
                <label class="searchbox orders-filter time-frame">
                  <img src="/icons/{{baseSiteId}}/calendar.svg" alt="" />
                  <input type="text" placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}" class="input-filter"
                    [(ngModel)]="toDate" (ngModelChange)="validateDate()" bsDatepicker [minDate]="minSelectionDate"
                    [daysDisabled]="[0, 6]" [bsConfig]="{
                      containerClass: 'order-list-date',
                      dateInputFormat: 'MM/DD/YYYY'
                    }" />
                </label>
              </div>
            </fieldset>
          </div>
        </div>
        <span class="dateError" *ngIf="dateError">{{
          "ordersList.invalidDateErrMsg" | cxTranslate
          }}</span>
        <span class="dateError" *ngIf="singleDateError">{{
          "ordersList.selectBothDate" | cxTranslate
          }}</span>
      </div>
      <!--End-->
      <form [formGroup]="filterForm">
        <div class="filterByGroup">
          <div class="filterByTitle mb-2">
            <label for="invoice">{{
              "ordersList.invoice" | cxTranslate
              }}</label>
          </div>
          <div class="headSearch-holder">
            <div class="searchbox orders-filter time-frame">
              <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
                aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="invoice"
                (keypress)="onKeyPress($event.target.value)" formControlName="invoice" />
              <button role="presentation" class="search-icon">
                <span class="searchicon"
                  style="background: url(/icons/{{baseSiteId}}/search_new.svg) no-repeat;"></span>
              </button>
            </div>
          </div>

          <div class="filterByTitle mb-2">
            <label for="poNumber">PO Number #</label>
          </div>
          <div class="headSearch-holder">
            <div class="searchbox orders-filter time-frame">
              <input placeholder="Search" type="text" maxlength="35" autocomplete="off"
                aria-describedby="initialDescription" aria-controls="results" aria-autocomplete="both"
                class="input-filter" [(ngModel)]="poNumber" formControlName="ponumber"
                (keypress)="onKeyPress($event.target.value)" />
              <button role="presentation" class="search-icon">
                <span class="searchicon"
                  style="background: url(/icons/{{baseSiteId}}/search_new.svg) no-repeat;"></span>
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="account-order-filter-btn d-flex flex-column">
        <button type="submit" class="btn-primary mb-3" data-di-id="di-id-362f2c77-5f23e741"
          [disabled]="!isFilterSelected" (click)="applyFilter()">
          {{ "ordersList.applyFilters" | cxTranslate }}
        </button>
        <button type="button" id="clearOrderFiltersBtn" class="btn-secondary" data-di-id="#clearOrderFiltersBtn"
          (click)="clearFilters()">
          {{ "ordersList.clearFilters" | cxTranslate }}
        </button>
      </div>
    </fieldset>
    <div class="line-intersection"></div>
    <section class="banner-section">
      <div>
        <app-flu-dashboard-banner bannerComponent="OrderHistoryBannerComponent"></app-flu-dashboard-banner>
      </div>
    </section>
  </aside>
  <section class="col-md-9 col-sm-9 col-lg-10 table-s-section float-right position-relative">
    @if (!paymentSummary && totalPayments) {
      <mat-spinner class="spinner absolute" mode="indeterminate" diameter="100"></mat-spinner>
    }
    <section class="filter-section">
      <section class="row">
        <section class="col-sm-12 col-md-12 col-md-12 col-xs-12 op_ovice">
          <div id="filter-applied" class="applied-filter">
            <div class="row row-20 page-section">
              <div class="col-md-7 col-sm-6 hidden-xs filterApply-showing">
                <span>{{ "ordersList.showing" | cxTranslate }} <ng-container *ngIf='startCount > 0'>{{startCount}} -
                  </ng-container>{{ end }}
                  {{ "ordersList.of" | cxTranslate }}
                  {{ totalPayments }}
                  Payments</span>
              </div>
              <div class="col-md-5 col-sm-6 top-pagination left-pagination">
                <div class="time-frame">
                  <span class="top-page-id mr-2 pt-1" id="accPageInfo">{{ "ordersList.page" | cxTranslate }} {{ curPage
                    }}
                    {{ "ordersList.of" | cxTranslate }}
                    {{ numberOfPages() }}</span>
                  <div class="pagination">
                    <button [disabled]="curPage == 1" (click)="getCurrentPage('prev');getPaymentList()"
                    class="pagination-btns mr-1">
                <span class="chevronIconWhite1 prev"> < </span></button>

                  <button class="pagination-btns"
                  [disabled]="
                      curPage >= totalPayments / pageSize ||
                      (totalPayments === 0 && pageSize === 0)
                    " (click)="getCurrentPage('next');getPaymentList()">
               <span class="chevronIconWhite1 next"> > </span>
               </button>
                  </div>
                </div>
              </div>
            </div>
            <hr class="hidden-xs" />
            <div class="row row-20" [ngClass]="
                facetsList.length > 2 ? 'page-dropdown-ipad' : 'page-dropdown'
              ">
              <div class="col-md-8 col-sm-7 hidden-xs applied-filters">
                {{ "ordersList.filtersApplied" | cxTranslate }}
                <span *ngIf="!facetsList.length">{{
                  "ordersList.none" | cxTranslate
                  }}</span>
                <span id="applied-filters" class="ml-2">
                  <span class="filterText focus mr-1 mb-2" tabindex="0" *ngFor="let filter of facetsList">
                    <div>
                      {{ filter.value
                      }}<img src="/icons/{{baseSiteId}}/close.svg" alt="" class="remove-facet"
                        (click)="removeFacet(filter)" />
                      <span class="filterRemove"></span>
                    </div>
                  </span><a class="clear-filters ml-1" (click)="clearFilters()" *ngIf="facetsList.length">{{
                    "ordersList.clearAllFilters" | cxTranslate }}</a>
                </span>
              </div>
              <div class="col-md-4 col-sm-5 col-xs-12 sortBy-select px-12">
                <ng-select name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false" bindLabel="name"
                  bindValue="code" class="set-pagination" [(ngModel)]="pageSizeperPage" (change)="changePageSize()"
                  (change)="applyFilter()"></ng-select>
              </div>
            </div>
          </div>
          <div class="flu_chart ph_chart" *ngIf="totalPayments">
            <div class="row not-mobile-view-pie">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h3 class="light-color">
                  Payment summary {{ paymentFromDate }} - {{ paymentToDate }}
                </h3>
              </div>
            </div>
            <div class="row chart-table not-mobile-view-pie">
              <div class="col-sm-12 col-md-5 col-lg-6 px0">
                <div id="pie_chart-ph">
                  <div class="chartGroup">
                    <div id="pie_chart-flu-overview">
                      <div class="chartjs-container">
                        <canvas id="doughnut-chart" baseChart [datasets]="doughnutChartData"
                          [chartType]="doughnutChartType" [type]="doughnutChartType" [options]="pieChartOptions"
                          [legend]="false" [tooltip]="false" [colors]="doughnutChartColors"
                          [labels]="doughnutChartLabels" style="
                            display: block !important;
                            height: 260px !important;
                            width: 500px !important;
                          ">
                        </canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-7 col-lg-4">
                <table class="fluoverview-table">
                  <tbody class="datatable-row">
                    <ng-container *ngFor="
                        let property of paymentSummary | keyvalue;
                        let i = index
                      ">
                      <tr class="phtable_cards" *ngIf="property.value > 0">
                        <td class="py-type">
                          <span class="pay-dot cards_pie" [style.background]="getBackgroundColor(i)"></span><a
                            title="Credit/Debit cards" *ngIf="property.key === 'achTotal'">Checking accounts
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'creditMemoTotal'">Credit memo
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'adjustmentTotal'">Adjustment
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'checksTotal'">Checks
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'creditCardsTotal'">Credit/Debit cards
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'creditTotal'">Credits</a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'electronicWireTotal'">Electronic Wire
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'overpaymentTotal'">Over
                            payment
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'refundsTotal'">Refunds
                          </a>
                          <a title="Credit/Debit cards" *ngIf="property.key === 'electronicChecksTotal'">Electronic
                            checks
                          </a>
                        </td>
                        <td>
                          {{ property.value | currency}}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>

    <!--STARTS !st SECTION-->

    <div id="filter-applied" class="applied-filter1 mobile-view-pie">
      <hr class="hidden-xs" />
      <div class="row row-20" [ngClass]="
          facetsList.length > 2 ? 'page-dropdown-ipad' : 'page-dropdown'
        ">
        <div class="col-md-8 col-sm-7 hidden-xs applied-filters mobile-filters">
          {{ "ordersList.filtersApplied" | cxTranslate }}
          <span *ngIf="!facetsList.length">{{
            "ordersList.none" | cxTranslate
            }}</span>
          <span id="applied-filters" class="ml-2">
            <span class="filterText focus mr-1 mb-2" tabindex="0" *ngFor="let filter of facetsList">
              <div>
                {{ filter.value
                }}<img src="/icons/close_w.png" alt="" class="remove-facet"
                  (click)="removeFacet(filter)" />
                <span class="filterRemove"></span>
              </div>
            </span><a class="clear-filters ml-1" (click)="clearFilters()" *ngIf="facetsList.length">{{
              "ordersList.clearAllFilters" | cxTranslate }}</a>
          </span>
        </div>
        <div class="col-md-4 col-sm-5 col-xs-12 sortBy-select px-12 mobile-filters" *ngIf='totalPayments > 0'>
          <ng-select name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false" bindLabel="name"
            bindValue="code" class="set-pagination" [(ngModel)]="pageSizeperPage" (change)="changePageSize()"
            (change)="applyFilter()"></ng-select>
        </div>
      </div>
    </div>

    <!--ENDS !st SECTION-->
    <div *ngIf="!totalPayments" class="empty-list mobile-filters">No information found</div>
    <section class="payment-section filter-section" [ngClass]="totalPayments > 0 ? '' : 'only-mobile-view'">
      <section class="dispaly-refine">
        <ng-template #facetsRwd class="select-refine">
          <section class="modal-class">
            <section class="modal-heading">
              <h2>
                <span class="close-icon" aria-hidden="true" (click)="hide()">&times;</span>
              </h2>
              <h2 class="select-heading">
                {{ "plp.selectRefinement" | cxTranslate }}
              </h2>
            </section>
            <section>
              <fieldset class="orderstatus-style">
                <div class="filterByGroup">
                  <div class="filterByTitle">
                    <label for="invoice">Payment type</label>
                    <div>
                      <ng-select name="orderstatus" [items]="PaymentMethodList" [searchable]="false" [clearable]="false"
                        bindLabel="name" bindValue="code" class="dropdown-credit" (change)="onKeyPress($event)" dropdownPosition="bottom"
                        [(ngModel)]="paymentMethod"></ng-select>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset id="filter-by">
                <legend class="filterByTitle-main order-history-search">
                  {{ "ordersList.searchBy" | cxTranslate }}
                </legend>
                <div class="grey-line"></div>
                <div class="filterByGroup mb-3">
                  <div class="filterByTitle">
                    <label for="invoice">{{
                      "ordersList.timeFrame" | cxTranslate
                      }}</label>
                  </div>
                  <ng-select name="timeFrame" [items]="timeFrameList" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="code" class="dropdown-credit" (ngModelChange)="clearDateRange()"
                    [(ngModel)]="timeFrame">
                  </ng-select>
                </div>
                <div class="filterByGroup">
                  <div class="filterByTitle">
                    <label for="invoice">{{
                      "ordersList.dateRange" | cxTranslate
                      }}</label>
                  </div>
                  <div class="time-frame">
                    <div class="pr-4 template-date">
                      <div class="control-group mb-2">
                        <label for="fromDate" aria-labelledby="dataRange fromDate">{{ "ordersList.from" | cxTranslate
                          }}</label>
                      </div>
                      <div class="headSearch-holder">
                        <label class="searchbox orders-filter time-frame">
                          <img src="/icons/calendar.svg" alt="" />
                          <input type="text" placeholder="{{
                              'ordersList.dateFormat' | cxTranslate
                            }}" class="input-filter" [(ngModel)]="fromDate" (ngModelChange)="validateDate()"
                            bsDatepicker [minDate]="minSelectionDate" [daysDisabled]="[0, 6]" [bsConfig]="{
                              containerClass: 'order-list-date',
                              dateInputFormat: 'MM/DD/YYYY'
                            }" />
                        </label>
                      </div>
                    </div>
                    <div class="template-to-date">
                      <div class="control-group mb-2">
                        <label for="toDate" aria-labelledby="dataRange toDate">{{ "ordersList.to" | cxTranslate
                          }}</label>
                      </div>
                      <div class="headSearch-holder">
                        <label class="searchbox orders-filter time-frame">
                          <img src="/icons/calendar.svg" alt="" />
                          <input type="text" placeholder="{{
                              'ordersList.dateFormat' | cxTranslate
                            }}" class="input-filter delivery-pickup-calendar" [(ngModel)]="toDate"
                            (ngModelChange)="validateDate()" bsDatepicker [minDate]="minSelectionDate"
                            [daysDisabled]="[0, 6]" [bsConfig]="{
                              containerClass: 'order-list-date',
                              dateInputFormat: 'MM/DD/YYYY'
                            }" />
                        </label>
                      </div>
                    </div>
                  </div>
                  <span class="dateError" *ngIf="dateError">{{
                    "ordersList.invalidDateErrMsg" | cxTranslate
                    }}</span>
                  <span class="dateError" *ngIf="singleDateError">{{
                    "ordersList.selectBothDate" | cxTranslate
                    }}</span>
                  <hr />
                </div>
                <form [formGroup]="filterForm">
                  <div class="filterByGroup">
                    <div class="filterByTitle mb-2">
                      <label for="invoice">{{
                        "ordersList.invoice" | cxTranslate
                        }}</label>
                    </div>
                    <div class="headSearch-holder">
                      <div class="searchbox orders-filter time-frame">
                        <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
                          aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="invoice"
                          (keypress)="onKeyPress($event.target.value)" formControlName="invoice" />
                        <button role="presentation" class="search-icon">
                          <span class="searchicon"
                            style="background: url(/icons/{{baseSiteId}}/search_new.svg) no-repeat;"></span>
                        </button>
                      </div>
                    </div>

                    <div class="filterByTitle mb-2">
                      <label for="poNumber">PO Number #</label>
                    </div>
                    <div class="headSearch-holder">
                      <div class="searchbox orders-filter time-frame">
                        <input placeholder="Search" type="text" maxlength="35" autocomplete="off"
                          aria-describedby="initialDescription" aria-controls="results" aria-autocomplete="both"
                          class="input-filter" [(ngModel)]="poNumber" (keypress)="onKeyPress($event.target.value)"
                          formControlName="ponumber" />
                        <button role="presentation" class="search-icon">
                          <!-- <cx-icon [type]="iconTypes.SEARCH"></cx-icon> -->
                          <span class="searchicon"
                            style="background: url(/icons/{{baseSiteId}}/search_new.svg) no-repeat;"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="
                    account-order-filter-btn
                    input-search
                    d-flex
                    flex-column
                  ">
                  <button type="button" class="btn-primary mb-3" [disabled]="!isFilterSelected"
                    (click)="applyFilter('mobile')">
                    {{ "ordersList.applyFilters" | cxTranslate }}
                  </button>
                  <button type="button" id="clearOrderFiltersBtn" class="btn-secondary" (click)="clearFilters()">
                    {{ "ordersList.clearFilters" | cxTranslate }}
                  </button>
                </div>
              </fieldset>
            </section>
            <footer class="p-2 input-search">
              <button class="btn btn-default blue-button done" (click)="applyFilter('mobile');hide()">
                {{ "ordersList.done" | cxTranslate }}
              </button>
            </footer>
          </section>

        </ng-template>

        <p class="top-pagination">
          {{ "ordersList.showing" | cxTranslate }} &nbsp;
          <span class="no_rec">{{ end }}</span>&nbsp; {{ "ordersList.of" | cxTranslate }} &nbsp;
          <span class="no_rec">{{ totalPayments }}</span>&nbsp; Payments
        </p>
        <div class="account-order-filter-btn mb-1">
          <button class="btn btn-default white-button" data-di-id="#refineBtn" (click)="refine()">
            {{ "ordersList.refine" | cxTranslate }}
          </button>
        </div>

        <div *ngIf="!totalPayments" class="empty-list">No information found</div>


        <div class="row mobile-view-pie" *ngIf="totalPayments">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h3 class="light-color">
              Payment summary {{ paymentFromDate }} - {{ paymentToDate }}
            </h3>
          </div>
        </div>
        <div class="row chart-table mobile-view-pie" *ngIf="totalPayments">
          <div class="col-sm-12 col-md-5 px0">
            <div id="pie_chart-ph">
              <div class="chartGroup">
                <div id="pie_chart-flu-overview">
                  <div class="chartjs-container">
                    <canvas id="doughnut-chart" baseChart [datasets]="doughnutChartData" [chartType]="doughnutChartType"
                      [type]="doughnutChartType" [options]="pieChartOptions" [colors]="doughnutChartColors"
                      [labels]="doughnutChartLabels" [legend]="false" [tooltip]="false" style="
                        display: block !important;
                        width: 350px !important;
                        height: 350px !important;
                        margin: 0 auto !important;
                      ">
                    </canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 col-lg-4">
            <div class="fluoverview-table">
              <div class="datatable-row">
                <ng-container *ngFor="
                    let property of paymentSummary | keyvalue;
                    let i = index
                  ">
                  <div class="phtable_cards" *ngIf="property.value > 0">
                    <div class="py-type">
                      <span class="pay-dot cards_pie" [style.background]="getBackgroundColor(i)"></span><a
                        title="Credit/Debit cards" *ngIf="property.key === 'achTotal'">Checking accounts
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'creditMemoTotal'">Credit memo
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'adjustmentTotal'">Adjustment
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'checksTotal'">Checks
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'creditCardsTotal'">Credit/Debit
                        cards
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'creditTotal'">Credits</a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'electronicWireTotal'">Electronic
                        Wire
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'overpaymentTotal'">Over payment
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'refundsTotal'">Refunds
                      </a>
                      <a title="Credit/Debit cards" *ngIf="property.key === 'electronicChecksTotal'">Electronic
                        checks
                      </a>
                    </div>
                    <div>
                      {{ property.value | currency}}
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="row" *ngIf="totalPayments">
        <div class="col-sm-4 col-md-5 col-lg-5">
          <h3>All payments</h3>
        </div>
        <div class="col-sm-5 col-md-4 col-lg-4">
          <div class="filterByGroup mb-3">
            <ng-select name="timeFrame" [items]="PaymentMethodList" [searchable]="false" [clearable]="false"
              bindLabel="name" bindValue="code" class="dropdown-credit" [(ngModel)]="paymentMethod"
              (change)="paymentMethodSelected()" placeholder="Filter by: Payment method">
            </ng-select>
          </div>
        </div>
        <input type="hidden" name="paymentMethod" id="payment-hist-paymentMethod" size="16" value=""
          data-di-id="#payment-hist-paymentMethod" placeholder="Filter by: Payment method" />
        <div class="col-sm-3 col-md-3 col-lg-3 ad-files-text hidden-xs">
          <a (click)="generateXlsSheetAndPdf('excel')" id="paymentHistoryXLS" aria-label="download payment history as"
            data-di-id="#paymentHistoryXLS">
            <img src="/icons/{{baseSiteId}}/excel_new.png" alt="" class="ad-pdf" target="_blank" />
            <span class="p_icon">XLS</span></a>
          <a (click)="generateXlsSheetAndPdf('pdf')" id="paymentHistoryPDF" aria-label="download payment history as"
            data-di-id="#paymentHistoryPDF">
            <img src="/icons/{{baseSiteId}}/pdf.png" alt="" class="ad-pdf" target="_blank" /><span
              class="p_icon">
              PDF</span></a>
        </div>
      </div>
      <table *ngIf="totalPayments" aria-describedby="invoicesTable" id="ordersTable"
        class="order-list-table table table-striped">
        <thead>
          <tr>
            <th scope="col" class="date-title" (click)="sortColumnByApi('accNo', $event)">
              Location Name &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="type-title" (click)="sortColumnByApi('accNo', $event)">
              Account # &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" (click)="sortColumnByApi('dueDate', $event)" class="order-title white-wrap">
              Due date &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" (click)="sortColumnByApi('paymentDate', $event)" class="status-title white-wrap">
              Date paid &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="po-title" (click)="sortColumnByApi('invoiceNo', $event)">
              Invoice # &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="payment-text-th" (click)="sortColumnByApi('poNo', $event)">
              <div class="payment-text-th">PO # &nbsp;</div>
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="invoice-title" (click)="sortColumnByApi('invoiceAmount', $event)">
              Invoice amount &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="tracking-title" (click)="sortColumnByApi('discountAmount', $event)">
              Prompt pay discount &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="tracking-title" (click)="sortColumnByApi('plannedAmount', $event)">
              Amount paid &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="payment-text-th" (click)="sortColumnByApi('paymentMethod', $event)">
              <div class="payment-text-th">Payment method &nbsp;</div>
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="tracking-title" (click)="sortColumnByApi('invoiceBalance', $event)">
              Invoice balance &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th id="table1col10" class="glyph-three-pay-dots no-sort sorting_disabled" rowspan="1" colspan="1"
              aria-label="" style="width: 21.375px"></th>
          </tr>
        </thead>
        <tbody *ngIf="totalPayments">
          <ng-container *ngFor="let data of PaymentList; let i = index">
            <tr>
              <td class="paymenttd">
                <span>{{ data?.location }}</span>
              </td>
              <td class="paymenttd">
                <span>{{ data.accountNumber }}</span>
              </td>
              <td class="paymenttd">
                {{ data.dueDate }}
              </td>
              <td class="paymenttd">{{ data.paymentDate }}</td>
              <td class="paymenttd">
                <span
                  *ngIf="asmStringCheck(data?.invoiceNo); else notAsmUser">
                  {{data?.invoiceNo}}</span>
                <ng-template #notAsmUser>
                  <a (click)="generateInvoicePDF(data?.encryptedInvoiceNumber)">{{data?.invoiceNo}}</a>
                </ng-template>
              </td>
              <td class="paymenttd payment-method-td">
                <div (click)="generateInvoicePDF(data?.encryptedInvoiceNumber)" class="pdf-text">
                  {{ data?.poNo }}
                </div>
              </td>
              <td class="paymenttd">
                ${{ data.invoiceAmount }}
              </td>
              <td class="paymenttd">
                <div class="pdf-text app-navigation-links" type="external">
                  ${{ data?.discountAmount }}
                </div>
              </td>
              <td class="paymenttd">
                ${{ data.plannedAmount }}
              </td>
              <td class="imgtxt paymenttd payment-method-td">
                <img src="/icons/check.svg" alt="check"
                  *ngIf="data.paymentMethod === 'Checking Account'" />
                <img src="/img/ccVISA.png" alt="visa" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'VISA'
                  " />
                <img src="/img/ccMC.png" alt="mc" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'MC'
                  " />
                <img src="/img/ccDISC.png" alt="disc" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'DISC'
                  " />
                <img src="/img/amex.png" alt="amex" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'AMEX'
                  " />
                <div class="payment-text">
                  <ng-container *ngIf="
                      data.paymentMethod !== 'Credit Card' &&
                      data.paymentMethod !== 'Checking Account'
                    ">
                    {{ data.paymentMethod }}
                  </ng-container>
                  <ng-container *ngIf="
                      data.paymentMethod === 'Electronic Wire' ||
                      data.paymentMethod === 'Pay by credit' ||
                      data.paymentMethod === 'Checking Account' ||
                      data.paymentMethod === 'Credit' ||
                      data.paymentMethod === 'Check'
                    "><span *ngIf="data.paymentMethod === 'Checking Account'">#</span>
                    <ng-container
                      *ngFor="let refNo of data.clearDocRef?.split(',') | slice:0:5;let i = index; let c= count">
                      <p class="m-0 d-flex">{{refNo}}<span *ngIf="i !== c - 1">,</span></p>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="
                      data.paymentMethod === 'Credit Card' ||
                      data.paymentMethod === 'Electronic Checks'
                    ">
                    <span *ngIf="data.paymentMethod === 'Credit Card'">#</span>
                    <span>{{ data.ccNum }}</span>
                  </ng-container>
                </div>
              </td>
              <td class="paymenttd">
                ${{ data.invoiceBalance }}
              </td>
              <td class="actions_dropdowns paymenttd" [ngbPopover]="actionsPopup" placement="left" triggers="click"
                #p1="ngbPopover">
                <span><i class="dot-icon fas fa-ellipsis-h fa-lg"></i></span>
                <ng-template #actionsPopup>
                  <ul class="drpdown">
                    <div class="dropdown_box">
                      <div class="dropdown_container">
                        <li class="issuedli">
                          <a (click)="goToTransactionalPage(data)">View transactional data</a>
                        </li>
                      </div>
                    </div>
                  </ul>
                </ng-template>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div class="row not-mobile-view-pie is-Ipad-View" *ngIf="totalPayments">
        <div class="col-md-6">
          <p class="starred-text">
            MPCC/WT - Manually Processed Credit Cards/Wire Transfers Payment
            method will display the last 4 digits of the original payment.Check
            payments may take up to 48 hours to be processed.
          </p>
        </div>
      </div>
      <section class="orders-table-orders">
        <div class="row orders-row-table" *ngFor="let data of PaymentList; let i = index">
          <div class="column header-column orders-table-col">
            <ul class="col-header-rwd">
              <li>
                <p>
                  <b>Location Name &nbsp;</b>
                </p>
                <p>
                  {{ data?.location }}
                </p>
              </li>
              <li>
                <p>
                  <b>Account # &nbsp;</b>
                </p>
                <p>
                  {{ data.accountNumber }}
                </p>
              </li>
              <li>
                <p>
                  <b>Due date &nbsp;</b>
                </p>
                <p>
                  {{data.dueDate | date: "dd/MM/yyyy" }}
                </p>
              </li>
              <li>
                <p>
                  <b>Date paid &nbsp;</b>
                </p>
                <p>
                  {{ data.paymentDate | date: "dd/MM/yyyy" }}
                </p>
              </li>
              <li>
                <p>
                  <b>Invoice # &nbsp;</b>
                </p>
                <p>
                  <span
                    *ngIf="asmStringCheck(data?.invoiceNo); else notAsmUser">
                    {{data?.invoiceNo}}</span>
                  <ng-template #notAsmUser>
                    <a (click)="generateInvoicePDF(data?.encryptedInvoiceNumber)">{{data?.invoiceNo}}</a>
                  </ng-template>
                </p>
              </li>
              <li>
                <p>
                  <b>PO # &nbsp;</b>
                </p>
                <p>
                  {{ data?.poNo }}
                </p>
              </li>
              <li>
                <p>
                  <b>Invoice amount &nbsp;</b>
                </p>
                <p>
                  ${{ data.invoiceAmount }}
                </p>
              </li>
              <li>
                <p>
                  <b>Prompt pay discount &nbsp;</b>
                </p>
                <p>
                  ${{ data?.discountAmount }}
                </p>
              </li>
              <li>
                <p>
                  <b>Amount paid &nbsp;</b>
                </p>
                <p>
                  ${{ data.plannedAmount }}
                </p>
              </li>
              <li>
                <p>
                  <b>Payment method &nbsp;</b>
                </p>
                <div class="mob-div">
                  <img src="/icons/check.svg" alt="check"
                    *ngIf="data.paymentMethod === 'Checking Account'" />
                  <img src="/img/ccVISA.png" alt="visa" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'VISA'
                  " />
                  <img src="/img/ccMC.png" alt="mc" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'MC'
                  " />
                  <img src="/img/ccDISC.png" alt="disc" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'DISC'
                  " />
                  <img src="/img/amex.png" alt="amex" class="visa-card" *ngIf="
                    data.paymentMethod === 'Credit Card' &&
                    data.cardType &&
                    data?.cardType.toUpperCase() === 'AMEX'
                  " />
                  <p *ngIf="
                    data.paymentMethod !== 'Credit Card' &&
                    data.paymentMethod !== 'Checking Account'
                  " class="m-0">
                    {{ data.paymentMethod }}
                  </p>
                  <p *ngIf="
                    data.paymentMethod === 'Electronic Wire' ||
                    data.paymentMethod === 'Pay by credit' ||
                    data.paymentMethod === 'Checking Account' ||
                    data.paymentMethod === 'Credit' ||
                    data.paymentMethod === 'Check'
                  ">


                    <ng-container
                    *ngFor="let refNo of data.clearDocRef?.split(',') | slice:0:5; let i=index; let c=count">
                      <div class="d-flex flex-row">
                        <ng-container *ngIf="data.paymentMethod === 'Checking Account'"><div>#</div></ng-container>
                        <p class="m-0 d-flex">{{refNo}}<span *ngIf="i !== c - 1">,</span></p>
                      </div>


                  </ng-container>
                  </p>
                  <p *ngIf="
                    data.paymentMethod === 'Credit Card' ||
                    data.paymentMethod === 'Electronic Checks'
                  ">
                    <ng-container *ngIf="data.paymentMethod === 'Credit Card'">#</ng-container>
                    {{ data.ccNum }}
                  </p>
                </div>
              </li>
              <li>
                <p>
                  <b>Invoice balance &nbsp;</b>
                </p>
                <p>
                  ${{ data.invoiceBalance }}
                </p>
              </li>
              <li>
                <p>
                  <b></b>
                </p>
                <div class="mob-dot-view">
                  <p class="actions_dropdowns" [ngStyle]="{'width': '10%'}" [ngbPopover]="actionsPopup" placement="left" triggers="click"
                    #p1="ngbPopover">
                    <span _ngcontent-serverapp-c587=""><i _ngcontent-serverapp-c587=""
                        class="dot-icon fas fa-ellipsis-h fa-lg"></i></span>
                    <ng-template #actionsPopup>
                      <ul class="drpdown">
                        <div class="dropdown_box">
                          <div class="dropdown_container">
                            <li class="issuedli">
                              <a (click)="goToTransactionalPage(data)">View transactional data</a>
                            </li>
                          </div>
                        </div>
                      </ul>
                    </ng-template>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="row mobile-view-pie">
          <div class="col-md-6">
            <p class="starred-text" *ngIf="totalPayments">
              MPCC/WT - Manually Processed Credit Cards/Wire Transfers Payment
              method will display the last 4 digits of the original
              payment.Check payments may take up to 48 hours to be processed.
            </p>
          </div>
        </div>
      </section>
    </section>
    <section *ngIf="totalPayments">
      <div id="prod-pagination">
        <p>
          {{ "ordersList.showing" | cxTranslate }} &nbsp;
          <span class="no_rec">{{ end }}</span>&nbsp; {{ "ordersList.of" | cxTranslate }} &nbsp;
          <span class="no_rec">{{ totalPayments }}</span>&nbsp; Payments
        </p>
        <p class="pagination align-btns">
          <button [disabled]="curPage == 1" (click)="getCurrentPage('prev');getPaymentList()"
         class="pagination-btns mr-1">
        <span class="chevronIconWhite prev">
         < </span>
         </button>
       <button class="pagination-btns" [disabled]="
        curPage >= totalPayments / pageSize || (totalPayments === 0 && pageSize === 0)
        " (click)="getCurrentPage('next');getPaymentList()" >
        <span class="chevronIconWhite next"> > </span>
         </button>
        </p>
        <p>
          <span>{{ "ordersList.page" | cxTranslate }} {{ curPage }}
            {{ "ordersList.of" | cxTranslate }} {{ numberOfPages() }}</span>
        </p>
      </div>
    </section>

    <div class="line-intersection mobile-view"></div>
    <section class="mobile-view">
      <div class="banner-img">
        <app-flu-dashboard-banner bannerComponent="OrderHistoryBannerComponent"></app-flu-dashboard-banner>
      </div>
    </section>
  </section>
</section>
